import Navbar from "../components/site/Navbar";
import Hero from "../components/site/Hero";
import StripeMarquee from "../components/site/StripeMarquee";
import Services from "../components/site/Services";
import Gallery from "../components/site/Gallery";
import About from "../components/site/About";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";

export default function LandingPage() {
  return (
    <main
      data-testid="landing-page"
      className="bg-[#F4F3EF] text-[#121C17] min-h-screen overflow-x-hidden"
    >
      <Navbar />
      <Hero />
      <StripeMarquee />
      <Services />
      <Gallery />
      <About />
      <Contact />
      <Footer />
    </main>
  );
}
